export default "__VITE_ASSET__CUULGb60__"